import { Component } from '@angular/core';

@Component({
  templateUrl: './eco-portal.component.html',
  standalone: false,
})
export class EcoPortalComponent {}
